import React, { useEffect, useState } from 'react';
import api from '../api/api';
import { pdf } from '@react-pdf/renderer';
import ExportPDFJobOffer from './ExportPDFJobOffer';
import { useAuth } from '../context/AuthContext';
// eslint-disable-next-line react/prop-types
const JobOffer = ({idBiodata,booking_id}) => {
  const [formData, setFormData] = useState({
    // Agency/Employer
    agency: '',
    agencyAddress: '',
    agencyPhone: '',
    
    // FDW
    fdwName: '',
    careRecipient: '',
    
    // Employer's Family Profile
    employerName: '',
    employerNationality: '',
    numAdults: '',
    numChildren: '',
    numInfants: '',
    numElderly: '',
    health: [],
    healthOthers: '',
    
    // Dwelling
    dwelling: '',
    levels: '1',
    bedrooms: '3',
    toilets: '2',
    
    // Duties
    duties: [],
    numCars: '0',
    carDetails: '',
    specialRequirements: '',
    nightFeedingFreq: '',
    
    // Employment Terms
    basicSalary: '',
    restDays: '',
    compensInLieu: '',
    restArrangement: '',
    restHours: '',
    restDayTime: '',
    phoneUsage: '',
    religiousPractice: '',
    
    // Additional
    additionalDuties: '',
    
    // Signatures
    employerSignatureName: '',
    employerIC: '',
    employerDate: '',
    fdwSignatureName: '',
    fdwIC: '',
    fdwDate: '',
    agencySignature: ''
  });


  useEffect(() => {
    // Fetch data for the booking_id
    fetchAgreementContractData();
  }, [booking_id]);

  const [agencyInfo, setAgencyInfo] = useState({})

  const fetchAgreementContractData = async () => {
    if (!booking_id) {
      console.log('No booking_id provided, keeping form initialized');
      return;
    }

    setIsLoading(true);
    try {
      console.log('Fetching Job Offer data for booking_id:', booking_id);
      const response = await api.get(`external-forms/job-offers/${booking_id}/`);
      
      if (response.data) {
        console.log('Job Offer data retrieved:', response.data);
        
        // Map backend field names to frontend form fields
        const backendData = response.data;
        setAgencyInfo({
          agencyAddress: backendData.agency_address || '',
          agencyPhone: backendData.agency_phone || ''
        });
        setFormData({
          agency: backendData.agency_name || '',
          agencyAddress: backendData.agency_address || '',
          agencyPhone: backendData.agency_phone || '',
          fdwName: backendData.fdw_name || '',
          careRecipient: backendData.care_recipient || '',
          employerName: backendData.employer_name || '',
          employerNationality: backendData.employer_nationality || '',
          numAdults: backendData.num_adults?.toString() || '2',
          numChildren: backendData.num_children?.toString() || '0',
          numInfants: backendData.num_infants?.toString() || '0',
          numElderly: backendData.num_elderly?.toString() || '0',
          health: backendData.health_conditions || [],
          healthOthers: backendData.health_others || '',
          dwelling: backendData.dwelling || '',
          levels: backendData.levels?.toString() || '1',
          bedrooms: backendData.bedrooms?.toString() || '3',
          toilets: backendData.toilets?.toString() || '2',
          duties: backendData.duties || [],
          numCars: backendData.num_cars?.toString() || '0',
          carDetails: backendData.car_details || '',
          specialRequirements: backendData.special_requirements || '',
          nightFeedingFreq: backendData.night_feeding_freq || '',
          basicSalary: backendData.basic_salary?.toString() || '600.00',
          restDays: backendData.rest_days?.toString() || '3',
          compensInLieu: backendData.compens_in_lieu?.toString() || '69.00',
          restArrangement: backendData.rest_arrangement || '',
          restHours: backendData.rest_hours || '',
          restDayTime: backendData.rest_day_time || '',
          phoneUsage: backendData.phone_usage || '',
          religiousPractice: backendData.religious_practice || '',
          additionalDuties: backendData.additional_duties || '',
          employerSignatureName: backendData.employer_signature_name || '',
          employerIC: backendData.employer_ic || '',
          employerDate: backendData.employer_date || '',
          fdwSignatureName: backendData.fdw_signature_name || '',
          fdwIC: backendData.fdw_ic || '',
          fdwDate: backendData.fdw_date || '',
          agencySignature: backendData.agency_signature || ''
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log('No existing Job Offer found for booking_id:', booking_id, '- keeping form initialized');
        // Keep the form in its initial state - no need to do anything
      } else {
        console.error('Error fetching Job Offer data:', error);
        // Keep the form in its initial state even if there's an error
      }
    } finally {
      setIsLoading(false);
    }
  };

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      if (name.includes('[]')) {
        const fieldName = name.replace('[]', '');
        setFormData(prev => ({
          ...prev,
          [fieldName]: checked 
            ? [...(prev[fieldName] || []), value]
            : (prev[fieldName] || []).filter(item => item !== value)
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          [name]: value
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    // Remove all required field validations - all fields are now optional
    // This allows the form to be submitted even with empty fields
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Clear previous errors
    setErrors({});
    
    // Validate form
    if (!validateForm()) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Prepare data for API submission, mapping frontend fields to backend fields
      const apiData = {
        booking: booking_id,
        fdw_name: formData.fdwName,
        care_recipient: formData.careRecipient,
        employer_name: formData.employerName,
        employer_nationality: formData.employerNationality,
        num_adults: parseInt(formData.numAdults) || 0,
        num_children: parseInt(formData.numChildren) || 0,
        num_infants: parseInt(formData.numInfants) || 0,
        num_elderly: parseInt(formData.numElderly) || 0,
        health_conditions: formData.health || [],
        health_others: formData.healthOthers,
        dwelling: formData.dwelling,
        levels: parseInt(formData.levels) || 1,
        bedrooms: parseInt(formData.bedrooms) || 1,
        toilets: parseInt(formData.toilets) || 1,
        duties: formData.duties || [],
        num_cars: parseInt(formData.numCars) || 0,
        car_details: formData.carDetails,
        special_requirements: formData.specialRequirements,
        night_feeding_freq: formData.nightFeedingFreq,
        basic_salary: parseFloat(formData.basicSalary) || 600.00,
        rest_days: parseInt(formData.restDays) || 3,
        compens_in_lieu: parseFloat(formData.compensInLieu) || 69.00,
        rest_arrangement: formData.restArrangement,
        rest_hours: formData.restHours,
        rest_day_time: formData.restDayTime,
        phone_usage: formData.phoneUsage,
        religious_practice: formData.religiousPractice,
        additional_duties: formData.additionalDuties,
        employer_signature_name: formData.employerSignatureName,
        employer_ic: formData.employerIC,
        employer_date: formData.employerDate || null,
        fdw_signature_name: formData.fdwSignatureName,
        fdw_ic: formData.fdwIC,
        fdw_date: formData.fdwDate || null,
        agency_signature: formData.agencySignature
      };

      console.log('Submitting Job Offer Form Data:', apiData);
      
      const response = await api.post('external-forms/job-offers/', apiData);
      console.log('Job Offer submitted successfully:', response.data);
      
      // Show success message
      alert('Job Offer form submitted successfully!');
      
      // Clear any errors
      setErrors({});
      
      // Optionally reset form after successful submission
      // handleReset();
      
    } catch (error) {
      console.error('Error submitting Job Offer form:', error);
      
      if (error.response && error.response.data) {
        console.error('Error details:', error.response.data);
        
        // Handle field-specific errors from backend
        if (typeof error.response.data === 'object') {
          setErrors(error.response.data);
        } else {
          alert(`Error submitting form: ${JSON.stringify(error.response.data)}`);
        }
      } else {
        alert('Error submitting form. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleReset = () => {
    setErrors({}); // Clear errors
    setFormData({
      agency: '',
      agencyAddress: '',
      agencyPhone: '',
      fdwName: '',
      careRecipient: '',
      employerName: '',
      employerNationality: '',
      numAdults: '2',
      numChildren: '0',
      numInfants: '0',
      numElderly: '0',
      health: [],
      healthOthers: '',
      dwelling: '',
      levels: '1',
      bedrooms: '3',
      toilets: '2',
      duties: [],
      numCars: '0',
      carDetails: '',
      specialRequirements: '',
      nightFeedingFreq: '',
      basicSalary: '600.00',
      restDays: '3',
      compensInLieu: '69.00',
      restArrangement: '',
      restHours: '',
      restDayTime: '',
      phoneUsage: '',
      religiousPractice: '',
      additionalDuties: '',
      employerSignatureName: '',
      employerIC: '',
      employerDate: '',
      fdwSignatureName: '',
      fdwIC: '',
      fdwDate: '',
      agencySignature: ''
    });
  };

  const handleDelete = async () => {
    if (!booking_id) {
      alert('No booking ID provided for deletion');
      return;
    }

    const confirmDelete = window.confirm(
      'Are you sure you want to delete this Job Offer record? This action cannot be undone.'
    );

    if (!confirmDelete) {
      return;
    }

    setIsSubmitting(true);

    try {
      console.log('Deleting Job Offer for booking_id:', booking_id);
      const response = await api.delete(`external-forms/job-offers/${booking_id}/`);
      console.log('Job Offer deleted successfully:', response.data);
      
      // Show success message
      alert('Job Offer record deleted successfully!');
      
      // Reset the form after deletion
      handleReset();
      
      // Clear any errors
      setErrors({});
      
    } catch (error) {
      console.error('Error deleting Job Offer:', error);
      
      if (error.response && error.response.status === 404) {
        alert('Job Offer record deleted successfully!');
      } else if (error.response && error.response.data) {
        console.error('Error details:', error.response.data);
        alert('Error deleting record: ' + (error.response.data.error || 'Unknown error'));
      } else {
        alert('Error deleting record. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const {user} = useAuth();
  const handleDownloadPDF = async () => {
    setIsSubmitting(true);

    try {
      console.log('Generating Job Offer PDF for booking_id:', booking_id);
      
      // Get supplier/agency details if needed
      let responseDetails = null;
      if (booking_id) {
        try {
          // Try to get additional details from the backend if needed
          responseDetails = await api.get(`external-forms/job-offers/${booking_id}/`);
        } catch (error) {
          console.log('Could not fetch additional details, using form data only');
        }
      }
      
      // Prepare the data for PDF generation
      const pdfData = {
        ...formData,
        booking_id: booking_id
      };

      // Generate PDF using React PDF
      const blob = await pdf(
        <ExportPDFJobOffer
          user={user}
          data={pdfData}
          agencyInfo={agencyInfo}
          
        />
      ).toBlob();
      
      // Create blob link to download
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      // Generate filename with current date
      const today = new Date().toISOString().split('T')[0];
      const filename = booking_id 
        ? `Job_Offer_${booking_id}_${today}.pdf`
        : `Job_Offer_${today}.pdf`;
      link.setAttribute('download', filename);
      
      // Append to html link element page
      document.body.appendChild(link);
      
      // Start download
      link.click();
      
      // Clean up and remove the link
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      console.log('Job Offer PDF generated and downloaded successfully');
      
    } catch (error) {
      console.error('Error generating Job Offer PDF:', error);
      alert('Error generating PDF. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
   
      <div className="page-wrapper" style={{ marginLeft: '0' }}>
        <div className="content container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="content-page-header">
                    <h5>Job Offer / Offer of Employment (FDW)</h5>
                  </div>

                  {/* Loading Indicator */}
                  {isLoading && (
                    <div className="d-flex justify-content-center align-items-center py-5">
                      <div className="spinner-border text-primary me-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <span className="text-muted">Loading existing job offer data...</span>
                    </div>
                  )}

                  {/* Form Content - Hidden during loading */}
                  <div style={{ display: isLoading ? 'none' : 'block' }}>
                  <form onSubmit={handleSubmit}>
                    {/* Agency / Employer Section */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Agency / Employer</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Agency</label>
                              <input
                                type="text"
                                name="agency"
                                value={formData.agency}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Agency Address</label>
                              <input
                                type="text"
                                name="agencyAddress"
                                value={formData.agencyAddress}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Agency Phone</label>
                              <input
                                type="text"
                                name="agencyPhone"
                                value={formData.agencyPhone}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Offer made to (FDW) Section */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Offer made to (FDW)</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Name of FDW</label>
                              <input
                                type="text"
                                name="fdwName"
                                value={formData.fdwName}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Care Recipient Name / NRIC</label>
                              <input
                                type="text"
                                name="careRecipient"
                                value={formData.careRecipient}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Employer's Family Profile Section */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Employer&apos;s Family Profile</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Employer&apos;s Name</label>
                              <input
                                type="text"
                                name="employerName"
                                value={formData.employerName}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Nationality</label>
                              <input
                                type="text"
                                name="employerNationality"
                                value={formData.employerNationality}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>

                        <label className="mb-2">Total members residing in the household</label>
                        <div className="row">
                          <div className="col-lg-3 col-6">
                            <div className="input-block mb-3">
                              <label>Adults</label>
                              <input
                                type="number"
                                name="numAdults"
                                value={formData.numAdults}
                                onChange={handleInputChange}
                                className="form-control"
                                min="0"
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-6">
                            <div className="input-block mb-3">
                              <label>Children</label>
                              <input
                                type="number"
                                name="numChildren"
                                value={formData.numChildren}
                                onChange={handleInputChange}
                                className="form-control"
                                min="0"
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-6">
                            <div className="input-block mb-3">
                              <label>Infants</label>
                              <input
                                type="number"
                                name="numInfants"
                                value={formData.numInfants}
                                onChange={handleInputChange}
                                className="form-control"
                                min="0"
                              />
                            </div>
                          </div>
                          <div className="col-lg-3 col-6">
                            <div className="input-block mb-3">
                              <label>Elderly</label>
                              <input
                                type="number"
                                name="numElderly"
                                value={formData.numElderly}
                                onChange={handleInputChange}
                                className="form-control"
                                min="0"
                              />
                            </div>
                          </div>
                        </div>

                        <label className="mb-2">Health / Mobility (tick where applicable)</label>
                        <div className="row">
                          {['Mobile', 'Immobile', 'Special Needs', 'Dementia', 'Stroke', 'Bedridden', 'Wheelchair Bound', 'Others'].map((option) => (
                            <div key={option} className="col-lg-3 col-6">
                              <div className="form-check mb-2">
                                <input
                                  type="checkbox"
                                  name="health[]"
                                  value={option}
                                  checked={(formData.health || []).includes(option)}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`health-${option}`}
                                />
                                <label className="form-check-label" htmlFor={`health-${option}`}>
                                  {option}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="col-12">
                          <div className="input-block mb-3">
                            <label>If &quot;Others&quot;, please describe</label>
                            <input
                              type="text"
                              name="healthOthers"
                              value={formData.healthOthers}
                              onChange={handleInputChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Type of Dwelling Section */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Type of Dwelling – FDW&apos;s place of work</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          {['Bungalow', 'Condo', 'Private Apartment', 'Landed Semi', 'Landed Terrace', 'HDB', 'HDB Maisonette', 'HDB Executive', 'Others'].map((option) => (
                            <div key={option} className="col-lg-3 col-6">
                              <div className="form-check mb-2">
                                <input
                                  type="radio"
                                  name="dwelling"
                                  value={option}
                                  checked={formData.dwelling === option}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`dwelling-${option}`}
                                />
                                <label className="form-check-label" htmlFor={`dwelling-${option}`}>
                                  {option}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="row mt-3">
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Levels</label>
                              <input
                                type="number"
                                name="levels"
                                value={formData.levels}
                                onChange={handleInputChange}
                                className="form-control"
                                min="0"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Bedrooms</label>
                              <input
                                type="number"
                                name="bedrooms"
                                value={formData.bedrooms}
                                onChange={handleInputChange}
                                className="form-control"
                                min="0"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Toilets</label>
                              <input
                                type="number"
                                name="toilets"
                                value={formData.toilets}
                                onChange={handleInputChange}
                                className="form-control"
                                min="0"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Duties Section */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Duties of the Domestic Worker (tick where applicable)</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          {[
                            'General housekeeping', 'Infant care', 'Toddler care', 'Childcare', 
                            'Marketing', 'Cooking', 'Laundry (Handwash)', 'Laundry (Machine)', 
                            'Carwash', 'Gardening', 'Pet care'
                          ].map((duty) => (
                            <div key={duty} className="col-lg-3 col-6">
                              <div className="form-check mb-2">
                                <input
                                  type="checkbox"
                                  name="duties[]"
                                  value={duty}
                                  checked={(formData.duties || []).includes(duty)}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`duty-${duty}`}
                                />
                                <label className="form-check-label" htmlFor={`duty-${duty}`}>
                                  {duty}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="row mt-3">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>No. of cars</label>
                              <input
                                type="number"
                                name="numCars"
                                value={formData.numCars}
                                onChange={handleInputChange}
                                className="form-control"
                                min="0"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Car details (No / Type / Size)</label>
                              <input
                                type="text"
                                name="carDetails"
                                value={formData.carDetails}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="e.g. 2; Sedan; Compact"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="input-block mb-3">
                            <label>Special Requirements / Additional duties</label>
                            <textarea
                              name="specialRequirements"
                              value={formData.specialRequirements}
                              onChange={handleInputChange}
                              className="form-control"
                              rows="4"
                              placeholder="Describe any special caregiving or other tasks..."
                            />
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="input-block mb-3">
                            <label>Night feeding frequency (if applicable)</label>
                            <input
                              type="text"
                              name="nightFeedingFreq"
                              value={formData.nightFeedingFreq}
                              onChange={handleInputChange}
                              className="form-control"
                              placeholder="e.g. every 3 hours"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Essential Terms of Employment Section */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Essential Terms of Employment</h6>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Basic Salary (S$)</label>
                              <input
                                type="number"
                                name="basicSalary"
                                value={formData.basicSalary}
                                onChange={handleInputChange}
                                className="form-control"
                                step="0.01"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Number of rest days per month</label>
                              <input
                                type="number"
                                name="restDays"
                                value={formData.restDays}
                                onChange={handleInputChange}
                                className="form-control"
                                min="0"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-12">
                            <div className="input-block mb-3">
                              <label>Compensation in lieu of rest days worked (S$)</label>
                              <input
                                type="number"
                                name="compensInLieu"
                                value={formData.compensInLieu}
                                onChange={handleInputChange}
                                className="form-control"
                                step="0.01"
                              />
                            </div>
                          </div>
                        </div>

                        <label className="mb-2">Rest Arrangement</label>
                        <div className="row">
                          {['Own room', 'Share room with others', 'Common area with privacy'].map((option) => (
                            <div key={option} className="col-lg-4 col-12">
                              <div className="form-check mb-2">
                                <input
                                  type="radio"
                                  name="restArrangement"
                                  value={option}
                                  checked={formData.restArrangement === option}
                                  onChange={handleInputChange}
                                  className="form-check-input"
                                  id={`rest-${option}`}
                                />
                                <label className="form-check-label" htmlFor={`rest-${option}`}>
                                  {option}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="row mt-3">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Rest hours</label>
                              <input
                                type="text"
                                name="restHours"
                                value={formData.restHours}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="e.g. 10pm - 6am"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Rest day (Day/Time)</label>
                              <input
                                type="text"
                                name="restDayTime"
                                value={formData.restDayTime}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="e.g. Sunday"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Handphone usage (notes)</label>
                              <input
                                type="text"
                                name="phoneUsage"
                                value={formData.phoneUsage}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="Allowed / Not allowed / Conditions"
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="input-block mb-3">
                              <label>Religious practice (notes)</label>
                              <input
                                type="text"
                                name="religiousPractice"
                                value={formData.religiousPractice}
                                onChange={handleInputChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Additional Duties Section */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Additional Duties (Caregiving arrangement)</h6>
                      </div>
                      <div className="card-body">
                        <div className="input-block mb-3">
                          <textarea
                            name="additionalDuties"
                            value={formData.additionalDuties}
                            onChange={handleInputChange}
                            className="form-control"
                            rows="4"
                            placeholder="Write additional caregiving arrangements..."
                          />
                        </div>
                      </div>
                    </div>

                    {/* Agreement & Signatures Section */}
                    <div className="card mb-4">
                      <div className="card-header">
                        <h6 className="mb-0">Agreement & Signatures</h6>
                      </div>
                      <div className="card-body">
                        <p className="text-muted small mb-4">
                          The Employer and FDW have mutually agreed and accepted the above stipulated duties as terms and conditions of the job offer and both Parties hereby authorise the Agency to perform all necessary transactions with MOM on their behalf.
                        </p>

                        <div className="row">
                          <div className="col-lg-6 col-12">
                            <div className="card">
                              <div className="card-body">
                                <h6 className="mb-3">Employer Signature</h6>
                                <div className="input-block mb-3">
                                  <label>Employer Name (signature)</label>
                                  <input
                                    type="text"
                                    name="employerSignatureName"
                                    value={formData.employerSignatureName}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Type name as signature"
                                  />
                                </div>
                                <div className="input-block mb-3">
                                  <label>IC No / ID</label>
                                  <input
                                    type="text"
                                    name="employerIC"
                                    value={formData.employerIC}
                                    onChange={handleInputChange}
                                    className="form-control"
                                  />
                                </div>
                                <div className="input-block mb-3">
                                  <label>Date</label>
                                  <input
                                    type="date"
                                    name="employerDate"
                                    value={formData.employerDate}
                                    onChange={handleInputChange}
                                    className={`form-control ${errors.employerDate ? 'is-invalid' : ''}`}
                                  />
                                  {errors.employerDate && (
                                    <div className="invalid-feedback">
                                      {errors.employerDate}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 col-12">
                            <div className="card">
                              <div className="card-body">
                                <h6 className="mb-3">FDW Signature</h6>
                                <div className="input-block mb-3">
                                  <label>FDW Name (signature)</label>
                                  <input
                                    type="text"
                                    name="fdwSignatureName"
                                    value={formData.fdwSignatureName}
                                    onChange={handleInputChange}
                                    className="form-control"
                                    placeholder="Type name as signature"
                                  />
                                </div>
                                <div className="input-block mb-3">
                                  <label>IC No / Passport</label>
                                  <input
                                    type="text"
                                    name="fdwIC"
                                    value={formData.fdwIC}
                                    onChange={handleInputChange}
                                    className="form-control"
                                  />
                                </div>
                                <div className="input-block mb-3">
                                  <label>Date</label>
                                  <input
                                    type="date"
                                    name="fdwDate"
                                    value={formData.fdwDate}
                                    onChange={handleInputChange}
                                    className={`form-control ${errors.fdwDate ? 'is-invalid' : ''}`}
                                  />
                                  {errors.fdwDate && (
                                    <div className="invalid-feedback">
                                      {errors.fdwDate}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="input-block mb-3">
                          <label>Agency acknowledgement (signature)</label>
                          <input
                            type="text"
                            name="agencySignature"
                            value={formData.agencySignature}
                            onChange={handleInputChange}
                            className="form-control"
                            placeholder="Agency authorized signatory"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Form Buttons */}
                    <div className="row">
                      <div className="col-12">
                        {/* Display errors */}
                        {Object.keys(errors).length > 0 && (
                          <div className="alert alert-danger mb-3">
                            <h6 className="mb-2">Please fix the following errors:</h6>
                            <ul className="mb-0">
                              {Object.entries(errors).map(([field, message]) => (
                                <li key={field}>
                                  <strong>
                                    {field === 'employerDate' ? 'Employer Date' :
                                     field === 'fdwDate' ? 'FDW Date' :
                                     field === 'employerName' ? 'Employer Name' :
                                     field === 'fdwName' ? 'FDW Name' :
                                     field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:
                                  </strong> {Array.isArray(message) ? message.join(', ') : message}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                        
                        <div className="btn-path text-end">
                          <button
                            type="button"
                            onClick={handleReset}
                            className="btn btn-cancel bg-primary-light me-3"
                            disabled={isSubmitting}
                          >
                            Reset
                          </button>
                          <button
                            type="button"
                            onClick={handleDelete}
                            className="btn btn-danger me-3"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Deleting...' : 'Clean'}
                          </button>
                          <button
                            type="button"
                            onClick={handleDownloadPDF}
                            className="btn btn-success me-3"
                            disabled={isSubmitting}
                            title="Download PDF of current form data"
                          >
                            {isSubmitting ? 'Generating...' : (
                              <>
                                <i className="fas fa-download me-2"></i>
                                Download PDF
                              </>
                            )}
                          </button>
                          <button 
                            type="submit" 
                            className="btn btn-primary"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Submitting...' : 'Save / Submit'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  </div> {/* End of form content div */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobOffer;